import {Icon} from '@/app/components/Icon';
import type {ReactNode} from 'react';
import {Additional} from '../../auth/types';
import {useGetAdditionalsQuery} from '../../../app/services/subscriptionApi';
export interface AdditionalInfoProps {
  additionalId: number;
  content?: (additional: Additional) => ReactNode;
}
export const AdditionalInfo = ({
  additionalId,
  content = (additional: Additional) => additional.name,
}: AdditionalInfoProps) => {
  const {data: additionals, error, isFetching} = useGetAdditionalsQuery();
  const additional = additionals?.find((additional) => additional.id === additionalId);
  return (
    <span>
      {isFetching && <Icon icon="spinner" spin />}
      {!isFetching && error && <Icon icon="exclamation-circle" className="text-red-400" />}
      {!isFetching && !error && additional && content(additional)}
      {!isFetching && !error && !additional && additionalId}
    </span>
  );
};
